import { IConfig } from "./Render";
export const Ellipse = ({cx, cy, rx, ry, stroke, stroke_width, fill }:IConfig)=>
{
    return (
       <ellipse cx ={cx} cy={cy} rx={rx} ry={ry} stroke={stroke} strokeWidth={stroke_width} fill={fill} ></ellipse>
    );
}